export function getHazardTypeByID(id: number) {
  return HazardTypes.find(item => item.id === id);
}

// Returns a hazard type as a stack to be used with iview cascade component
export function getHazardTypeStackByID(id: number) {
  const hazardType = HazardTypes.find(item => item.id === id);
  const hazardTypeStack = [];
  if (!!hazardType) {
    hazardTypeStack.push(hazardType.category);
    hazardTypeStack.push(hazardType.subcategory);
    hazardTypeStack.push(hazardType.type);
    hazardTypeStack.push(hazardType.id);
  }
  return hazardTypeStack;
}

export const HazardTypes = [
  {
    id: 1,
    subcategory: "Climatological",
    category: "Weather related",
    type: "Drought",
    subtype: "Drought",
  },
  {
    id: 2,
    subcategory: "Climatological",
    category: "Weather related",
    type: "Wildfire",
    subtype: "Wildfire",
  },
  {
    id: 3,
    subcategory: "Climatological",
    category: "Weather related",
    type: "Wildfire",
    subtype: "Wildfire - Forest",
  },
  {
    id: 4,
    subcategory: "Climatological",
    category: "Weather related",
    type: "Wildfire",
    subtype: "Wildfire - Land fire",
  },
  {
    id: 5,
    subcategory: "Climatological",
    category: "Weather related",
    type: "Extreme temperature",
    subtype: "Extreme temperature",
  },
  {
    id: 6,
    subcategory: "Climatological",
    category: "Weather related",
    type: "Extreme temperature",
    subtype: "Extreme temp, Extreme Heat / Heat Wave",
  },
  {
    id: 7,
    subcategory: "Climatological",
    category: "Weather related",
    type: "Extreme temperature",
    subtype: "Extreme temp, Winter Conditions / Cold Wave",
  },
  {
    id: 8,
    subcategory: "Climatological",
    category: "Weather related",
    type: "Extreme temperature",
    subtype: "Exterme temp, Severe winter conditions",
  },
  {
    id: 9,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Dry mass movement",
    subtype: "Dry mass movement",
  },
  {
    id: 10,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Dry mass movement",
    subtype: "Mass movement, Sudden subsidence/sinkhole",
  },
  {
    id: 11,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Dry mass movement",
    subtype: "Mass movement, Landslide",
  },
  {
    id: 12,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Dry mass movement",
    subtype: "Mass movement, Rock fall",
  },
  {
    id: 13,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Earthquake",
    subtype: "Earthquake",
  },
  {
    id: 14,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Earthquake",
    subtype: "Earthquake, Ground Shaking",
  },
  {
    id: 15,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Earthquake",
    subtype: "Earthquake, Tsunami",
  },
  {
    id: 16,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Volcanic eruption",
    subtype: "Volcanic eruption",
  },
  {
    id: 17,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Volcanic eruption",
    subtype: "Volcanic activity, Ash fall",
  },
  {
    id: 18,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Volcanic eruption",
    subtype: "Volcanic activity, Lahar",
  },
  {
    id: 19,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Volcanic eruption",
    subtype: "Volcanic activity, Pyroclastic flow",
  },
  {
    id: 20,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Volcanic eruption",
    subtype: "Volcanic activity, Lava flow",
  },
  {
    id: 21,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Volcanic eruption",
    subtype: "Volcanic activity, Toxic gases",
  },
  {
    id: 22,
    subcategory: "Hydrological",
    category: "Weather related",
    type: "Flood",
    subtype: "Flood",
  },
  {
    id: 23,
    subcategory: "Hydrological",
    category: "Weather related",
    type: "Flood",
    subtype: "Flash flood",
  },
  {
    id: 24,
    subcategory: "Hydrological",
    category: "Weather related",
    type: "Flood",
    subtype: "Coastal flood",
  },
  {
    id: 25,
    subcategory: "Hydrological",
    category: "Weather related",
    type: "Flood",
    subtype: "Riverine flood",
  },
  {
    id: 26,
    subcategory: "Hydrological",
    category: "Weather related",
    type: "Flood",
    subtype: "Ice jam flood",
  },
  {
    id: 27,
    subcategory: "Hydrological",
    category: "Weather related",
    type: "Flood",
    subtype: "Dam release flood",
  },
  {
    id: 28,
    subcategory: "Hydrological",
    category: "Weather related",
    type: "Wet mass movement",
    subtype: "Wet mass movement",
  },
  {
    id: 29,
    subcategory: "Hydrological",
    category: "Weather related",
    type: "Wet mass movement",
    subtype: "Landslide, Avalanche",
  },
  {
    id: 30,
    subcategory: "Hydrological",
    category: "Weather related",
    type: "Wet mass movement",
    subtype: "Wave action, Rogue wave",
  },
  {
    id: 31,
    subcategory: "Hydrological",
    category: "Weather related",
    type: "Wet mass movement",
    subtype: "Wave action, Seiche",
  },
  {
    id: 32,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Storm",
  },
  {
    id: 33,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Storm, Extra-tropical",
  },
  {
    id: 34,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Storm, Tropical",
  },
  {
    id: 35,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Storm, Convective",
  },
  {
    id: 36,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Tornado",
  },
  {
    id: 37,
    subcategory: "Climatological",
    category: "Weather related",
    type: "Wildfire",
    subtype: "Wildfire - Firenado",
  },
  {
    id: 38,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Storm, Tropical, Hurricane",
  },
  {
    id: 39,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Storm, Tropical, Cyclone",
  },
  {
    id: 40,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Hailstorm",
  },
  {
    id: 41,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Winter storm",
  },
  {
    id: 42,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Thunderstorm",
  },
  {
    id: 43,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Nor'wester",
  },
  {
    id: 44,
    subcategory: "Geophysical",
    category: "Geophysical",
    type: "Mass movement",
    subtype: "Glacial Lake Outburst Floods (GLOF)",
  },
  {
    id: 45,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Storm, Storm surge",
  },
  {
    id: 46,
    subcategory: "Meteorological",
    category: "Weather related",
    type: "Storm",
    subtype: "Storm, Tropical, Typhoon",
  },
  {
    id: 47,
    subcategory: "Other",
    category: "Other",
    type: "Other",
    subtype: "Other",
  },
  {
    id: 100,
    subcategory: "Unknown",
    category: "Other",
    type: "Unknown",
    subtype: "Unknown",
  },
];

export const HazardTypesTree = [
  {
    label: "Weather related",
    value: "Weather related",
    children: [
      {
        label: "Hydrological",
        value: "Hydrological",
        children: [
          {
            label: "Wet mass movement",
            value: "Wet mass movement",
            children: [
              {
                label: "Wet mass movement",
                value: 28,
              },
              {
                label: "Landslide, Avalanche",
                value: 29,
              },
              {
                label: "Wave action, Rogue wave",
                value: 30,
              },
              {
                label: "Wave action, Seiche",
                value: 31,
              },
            ],
          },
          {
            label: "Flood",
            value: "Flood",
            children: [
              {
                label: "Flood",
                value: 22,
              },
              {
                label: "Flash flood",
                value: 23,
              },
              {
                label: "Coastal flood",
                value: 24,
              },
              {
                label: "Riverine flood",
                value: 25,
              },
              {
                label: "Ice jam flood",
                value: 26,
              },
              {
                label: "Dam release flood",
                value: 27,
              },
            ],
          },
        ],
      },
      {
        label: "Meteorological",
        value: "Meteorological",
        children: [
          {
            label: "Storm",
            value: "Storm",
            children: [
              {
                label: "Storm",
                value: 32,
              },
              {
                label: "Storm, Extra-tropical",
                value: 33,
              },
              {
                label: "Storm, Tropical",
                value: 34,
              },
              {
                label: "Storm, Convective",
                value: 35,
              },
              {
                label: "Tornado",
                value: 36,
              },
              {
                label: "Storm, Tropical, Hurricane",
                value: 38,
              },
              {
                label: "Storm, Tropical, Cyclone",
                value: 39,
              },
              {
                label: "Hailstorm",
                value: 40,
              },
              {
                label: "Winter storm",
                value: 41,
              },
              {
                label: "Thunderstorm",
                value: 42,
              },
              {
                label: "Nor'wester",
                value: 43,
              },
              {
                label: "Storm, Storm surge",
                value: 45,
              },
              {
                label: "Storm, Tropical, Typhoon",
                value: 46,
              },
            ],
          },
        ],
      },
      {
        label: "Climatological",
        value: "Climatological",
        children: [
          {
            label: "Drought",
            value: "Drought",
            children: [
              {
                label: "Drought",
                value: 1,
              },
            ],
          },
          {
            label: "Wildfire",
            value: "Wildfire",
            children: [
              {
                label: "Wildfire",
                value: 2,
              },
              {
                label: "Wildfire - Forest",
                value: 3,
              },
              {
                label: "Wildfire - Land fire",
                value: 4,
              },
              {
                label: "Wildfire - Firenado",
                value: 37,
              },
            ],
          },
          {
            label: "Extreme temperature",
            value: "Extreme temperature",
            children: [
              {
                label: "Extreme temperature",
                value: 5,
              },
              {
                label: "Extreme temp, Extreme Heat / Heat Wave",
                value: 6,
              },
              {
                label: "Extreme temp, Winter Conditions / Cold Wave",
                value: 7,
              },
              {
                label: "Exterme temp, Severe winter conditions",
                value: 8,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    label: "Geophysical",
    value: "Geophysical",
    children: [
      {
        label: "Geophysical",
        value: "Geophysical",
        children: [
          {
            label: "Mass movement",
            value: "Mass movement",
            children: [
              {
                label: "Glacial Lake Outburst Floods (GLOF)",
                value: 44,
              },
            ],
          },
          {
            label: "Volcanic eruption",
            value: "Volcanic eruption",
            children: [
              {
                label: "Volcanic eruption",
                value: 16,
              },
              {
                label: "Volcanic activity, Ash fall",
                value: 17,
              },
              {
                label: "Volcanic activity, Lahar",
                value: 18,
              },
              {
                label: "Volcanic activity, Pyroclastic flow",
                value: 19,
              },
              {
                label: "Volcanic activity, Lava flow",
                value: 20,
              },
              {
                label: "Volcanic activity, Toxic gases",
                value: 21,
              },
            ],
          },
          {
            label: "Dry mass movement",
            value: "Dry mass movement",
            children: [
              {
                label: "Dry mass movement",
                value: 9,
              },
              {
                label: "Mass movement, Sudden subsidence/sinkhole",
                value: 10,
              },
              {
                label: "Mass movement, Landslide",
                value: 11,
              },
              {
                label: "Mass movement, Rock fall",
                value: 12,
              },
            ],
          },
          {
            label: "Earthquake",
            value: "Earthquake",
            children: [
              {
                label: "Earthquake",
                value: 13,
              },
              {
                label: "Earthquake, Ground Shaking",
                value: 14,
              },
              {
                label: "Earthquake, Tsunami",
                value: 15,
              },
            ],
          },
        ],
      },
    ],
  },
  {
      label: "Other",
      value: "Other",
      children: [{
          label: "Unknown",
          value: "Unknown",
          children: [{
              label: "Unknown",
              value: "Unknown",
              children: [{
                  label: "Unknown",
                  value: 100,
              }],
          }],
      }],
  },
];
